import React, { Component } from 'react';
import classNames from 'classnames';

import './styles.css';

/**
 * The navigation button for mobile/tablet.
 *
 * @typedef {Object} Props
 * @prop {String} [className]
 * @prop {Function} [onClick]
 * @prop {boolean} [open]
 *
 * @augments {Component<Props>}
 */
export default class NavButton extends Component {

	/** @param {React.SyntheticEvent} event */
	handleClick = (event) => this.props.onClick(event);

	genClassName = (props) => classNames('NavButton', props.className, {
		open: props.open,
	});

	render () {
		return (
			<button
				className={this.genClassName(this.props)}
				aria-pressed={this.props.open}
				onClick={this.props.onClick && this.handleClick}
			/>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/atoms/NavButton/NavButton.js